// scripts go here

// button -> modal script
window.addEventListener("load", function () {
    console.log('test');
    // interact with the alert dialog when active
    const checkboxes = {
        //'requestinfocheckbox': 'form_06158b5e-b8dc-4d17-b4b1-53b82e7e2b5f_1',
        'eventCheckbox': 'form_e3d340c3-146b-48ab-91d0-c943f953b90f_1'
    }

    // grab all applicable buttons
    const btns = document.querySelectorAll('.request-info, .request-event');

    let formscriptloaded = false;
    let formloaded = false;
    let formcheckoff = false;

    const selectEventCheckbox = () => {
        const checkbox = document.getElementById(checkboxes.eventCheckbox)
        if (formloaded && !checkbox.checked) {
            document.getElementById(checkboxes.eventCheckbox).click();
        }
        if (!formloaded) {
            formcheckoff = true 
        }
    }

    const unselectEventCheckbox = () => {
        const checkbox = document.getElementById(checkboxes.eventCheckbox)
        if (formloaded && checkbox.checked) {
            console.log('should be unchecking');
            document.getElementById(checkboxes.eventCheckbox).click();
        }
    }

    
    const slateProgramFilter = (includeArr, excludeArr = []) => {
        const selectElement = document.querySelector('#form_f8ded06e-c913-4efe-a115-27246fa6dcbb');
        const options = selectElement.querySelectorAll('option');
        
        options.forEach(option => {
            if (option.value && !(includeArr.some(str => option.innerText.toLowerCase().includes(str.toLowerCase())))) {
                option.setAttribute('hidden', true);
                option.setAttribute('disabled', true);
                if (!option.classList.contains('hidden')) {
                    option.classList.add('hidden');
                }
            }
        });

        // if we have an exclude array, hide those options
        if (excludeArr.length > 0) {
            options.forEach(option => {
                if (option.value && excludeArr.some(str => option.innerText.toLowerCase().includes(str.toLowerCase()))) {
                    option.setAttribute('hidden', true);
                    option.setAttribute('disabled', true);
                    if (!option.classList.contains('hidden')) {
                        option.classList.add('hidden');
                    }
                }
            });
        }

        // if there's only one option with a value, select that option
        const visibleOptions = selectElement.querySelectorAll('option:not([hidden])');
        if (visibleOptions.length == 2) {
            visibleOptions[1].selected = true;
        }

        // if there are no visible options, unhide every option we had hid
        if (visibleOptions.length == 1) {
            options.forEach(option => {
                if (option.value && !(includeArr.some(str => option.innerText.toLowerCase().includes(str.toLowerCase())))) {
                    option.removeAttribute('hidden');
                    option.removeAttribute('disabled');
                    if (option.classList.contains('hidden')) {
                        option.classList.remove('hidden');
                    }
                }
            });
        }
    }

    const loadformScript = formId => {
        if (formscriptloaded) {
            return;
        } 

        // create the slate script to add the form
        const script = document.createElement('script');
        script.async = 1;
        script.src = 'https://apply.monmouth.edu/register/?id=' + formId + '&output=embed&div=form_' + formId + '' + ((location.search.length > 1) ? '&' + location.search.substring(1) : '');
        const s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);

        formscriptloaded = true;
    }

    const loadForm = formId => {

        if (formloaded) {
            return;
        }

        const modal = document.createElement("dialog");
        modal.classList.add('slate');

        const headerHolder = document.createElement("div");
        headerHolder.classList.add('slate-header');
        modal.appendChild(headerHolder);

        const headertext = document.createElement("h2");
        headertext.classList.add('slate-header-text');
        headerHolder.appendChild(headertext);

        const close = document.createElement('button');
        close.classList.add('slate-close');
        close.innerHTML = '×';
        close.setAttribute('title', 'Close');
        headerHolder.appendChild(close);

        const modalbody = document.createElement('div');
        modalbody.classList.add('slate-body');

        const formholder = document.createElement('div');
        formholder.id = 'form_' + formId;
        formholder.innerText = "Loading...";
        modalbody.appendChild(formholder);
        modal.appendChild(modalbody);

        document.body.appendChild(modal);
        if (window.HTMLDialogElement === undefined) {
            window.scriptLoader(scriptBasePath + 'dialog-polyfill.js', () => {
                // only activate the modals if they're on the page
                dialogPolyfill.registerDialog(modal);
            });
        }

        // Callback function to execute when mutations are observed
        const callback = (mutationsList, observer) => {
            formloaded = true;
            if (formcheckoff) {
                selectEventCheckbox();
                formcheckoff = false;
            } else {
                unselectEventCheckbox();
            }

            // if we have the global "programStrings" variable, we can run the hider function
            if (typeof programStrings !== 'undefined') {
                if (typeof excludeStrings === 'undefined') {
                    slateProgramFilter(programStrings);
                } else {
                    slateProgramFilter(programStrings, excludeStrings);
                }
            }

            observer.disconnect();
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(formholder, { childList: true });

        close.addEventListener('click', function () {
            modal.close('cancelled');
        });
    
        modal.addEventListener('cancel', function () {
            modal.close('cancelled');
        });
    
        // close when clicking on backdrop
        modal.addEventListener('click', function (event) {
            if (event.target === modal) {
                modal.close('cancelled');
            }
        });
    }

    // go through each button and run the modal code
    [].forEach.call(btns, btn => {
        // get form ID from url
        const link = btn.querySelector('a');
        const url = link.getAttribute('href');
        const formId = url.split('id=')[1].split('&')[0];

        // if there's an ID, add the click event for the button
        link.addEventListener('click', e => {
            e.preventDefault();

            loadformScript(formId);
            loadForm(formId);

            // determine which text to display checkbox to select
            const formtype = btn.classList.contains('request-info') 
                ? 'info' 
                : 'event';

            const modal = document.querySelector('dialog.slate');
            const headertext = modal.querySelector('.slate-header-text');


            headertext.innerText = formtype === 'info' 
                ? "Request Information"
                : "Attend an Upcoming Event";

            if (!('showModal' in modal)) {
                modal.show();
            } else {
                modal.showModal();
            }

            if (formtype === 'event') {
                selectEventCheckbox();
            } else {
                unselectEventCheckbox();
            }
        })
    })
});
